import { z } from "zod";
import { UserSchema } from "../../models/User";
import { UserRole } from "@/users/models/UserRole";

export const GetCurrentUserOutputSchema = UserSchema.pick({
	id: true,
	username: true,
	firstName: true,
	lastName: true,
	email: true,
	phoneNumber: true,
}).extend({
	impersonatedUserId: z.number().nullable(),
	impersonatedCaregiverId: z.number().nullable(),
	role: z.nativeEnum(UserRole),
});

export type GetCurrentUserOutputType = z.infer<
	typeof GetCurrentUserOutputSchema
>;
